import React, { useEffect } from "react";
import FooterNew from "../components/Footer-New";
import NavbarInner from "../components/Navbar-Inner";
import BlogList from "../components/Blog/list.js";




export default function Live_Events() {

  return (
    <div>
    
      <NavbarInner />
      <div className="innerpages_wrapper">
        <div className="container-fluid">
          {/* <div className="inner_title_wrapper">
            <h2 className="inner_title">Staking</h2>
          </div> */}
          <div className="dash_wrapper">
            <BlogList />
          </div>
        </div>
      </div>
      <FooterNew/>
    </div>
  );
}
